import { Form } from "antd";
import { useTranslation } from "react-i18next";
import { HeaderOverview, IRenderBarChart, RenderBarChart } from "components";
import { useAppLanguage } from "providers/app-language";
import { useOverview } from "providers/overview";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  WrapperBG,
  checkData,
} from "pages/overview";
import { useGetDashboardTaskCategory } from "service/dashboard/central/task";
import { IData } from "service/dashboard/interface";

const WorkloadCard = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();
  const { translationObject } = useAppLanguage();

  const workloadDate = Form.useWatch("workloadDate");
  const date = findDate(workloadDate);

  const { data, isFetching, isError, error } = useGetDashboardTaskCategory({
    ...date,
    property,
  });

  if (isFetching) {
    return (
      <WrapperBG>
        <LoadingDashboard loading={isFetching}>
          <HeaderOverview
            title={t("statistics-of-workload")}
            name="workloadDate"
          />
          <div className="h-[300px]"></div>
        </LoadingDashboard>
      </WrapperBG>
    );
  }

  const findData = checkData(data);

  const getData: IData[] =
    findData?.map((e) => {
      const { title } = translationObject({ object: e, keys: ["title"] });
      return { name: title, count: e?.count || 0 };
    }) || [];

  const findNoCount = getData.some((e) => e.count > 0);

  const dataBar: IRenderBarChart = {
    data: getData,
    dataKeyX: "name",
    dataKeyY: "count",
    color: "#80BC28",
  };

  return (
    <WrapperBG>
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("statistics-of-workload")}
          name="workloadDate"
        />
        {isError ? (
          <ErrorDashboard error={error} height="300px" />
        ) : !findData || findData.length < 1 || !findNoCount ? (
          <NoDataDashboard height="300px" />
        ) : (
          <RenderBarChart {...dataBar} />
        )}
      </LoadingDashboard>
    </WrapperBG>
  );
};

export default WorkloadCard;
